import { api } from "@/lib/api";

export function getPosition(timeout = 8000) {
  return new Promise((resolve) => {
    if (!navigator.geolocation) return resolve(null);
    navigator.geolocation.getCurrentPosition(
      (p) => resolve([p.coords.latitude, p.coords.longitude]),
      () => resolve(null),
      { enableHighAccuracy: false, timeout, maximumAge: 300000 },
    );
  });
}

export async function fetchTrailheads(pathRef, pos) {
  const params = pos ? { lat: pos[0], lng: pos[1] } : {};
  const { data } = await api.get(`/public/paths/${encodeURIComponent(pathRef)}/trailheads`, { params });
  return data;
}

export const TYPE_LABEL = { trailhead: "Trailhead", parking: "Trail parking", trail_endpoint: "Trail end", nearest_point: "Nearest point on trail" };
